import { Container } from "@mui/material";
import styles from "./HomeFeature.module.scss";
import thumbnail from "Explore/Assets/homepage/homepage-search.png";
import { Fragment } from "react";

const HomeFeature = () => {
  return (
    <div className={styles["home-feature"]}>
      <Container maxWidth="lg" className={styles["home-feature__container"]}>
        <p className={styles["home-feature__container--title"]}>
          What do we have?
        </p>
        <div className={styles["home-feature__container--content"]}>
          <div className={styles["home-feature__container--content__left"]}>
            <div
              className={
                styles[
                  "home-feature__container--content__left--image__container"
                ]
              }
            >
              <img
                className={
                  styles["home-feature__container--content__left--image"]
                }
                src={thumbnail}
                alt="thumbnail"
              />
            </div>
          </div>
          <div className={styles["home-feature__container--content__right"]}>
            <p
              className={
                styles["home-feature__container--content__right--title"]
              }
            >
              Powerful Searching
            </p>
            <p
              className={
                styles["home-feature__container--content__right--description"]
              }
            >
              Effortlessly uncover the information you need with our intelligent
              keyword search. Our vast and comprehensive database ensures
              accurate results, while an extensive variety of filters allows you
              to refine your search and explore related entities quickly,
              efficiently, and with unmatched precision.
            </p>
            <div
              className={
                styles[
                  "home-feature__container--content__right--highlight__container"
                ]
              }
            >
              Try with:{" "}
              {[
                { name: "faculty", path: "faculties" },
                { name: "institution", path: "institutions" },
                { name: "unit", path: "units" },
                { name: "venue", path: "venues" },
                { name: "concept", path: "concepts" },
              ].map((item, i) => (
                <Fragment key={i}>
                  <a
                    href={`/explore/${item.path}`}
                    className={
                      styles[
                        "home-feature__container--content__right--highlight"
                      ]
                    }
                  >
                    {item.name[0].toUpperCase() + item.name.slice(1)}
                  </a>
                  {i < 3 ? ", " : ""}
                  {i === 3 ? " or " : ""}
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HomeFeature;
